// extracted by mini-css-extract-plugin
export var originalPrice = "_wj-0";